import React, { useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Container, Accordion, Offcanvas, Button, Tab, Tabs } from 'react-bootstrap';
import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { base_url, postHeader } from '../../../Helper/request';
import { Await, Navigate, useNavigate, useParams } from 'react-router-dom';
import Productfilter1 from './productfilter1';
import Productfilter2 from './Productfilter2';
import { useDispatch, useSelector } from 'react-redux';
import { addfilter, addOffset, caratfilter, categorydetails, listcategory, pricefilter, productcount, productlistdata, promostionCount, promotionProducts, quickship, sortby } from '../../../Reducer/productReducer';
import { Col, Row, Dropdown, DropdownButton, Form } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Link } from 'react-router-dom';
import { metaDetails } from '../../../Reducer/metaReducer';

const Filter = ({ filtercall }) => {
  // var pathname = window.location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const addedfilter = useSelector(state => state.persistedReducer.product.addedfilter);
  const InitialCaratfilter = useSelector(state => state.persistedReducer.product.caratfilter);
  const [show, setShow] = useState(false);
  const [customRedirect, setcustomRedirect] = useState(false)
  const quickshipvalue = useSelector(
    (state) => state.persistedReducer.product.quickshipvalue
  );
  const sortbyvalue = useSelector(
    (state) => state.persistedReducer.product.sortbyvalue
  );
  const promotionCountData = useSelector(
    (state) => state?.persistedReducer?.product?.promostionCount
  );
   const promotionsItem = useSelector(
    (state) => state?.persistedReducer?.product?.promotionProducts
  );
  const Product = useSelector((state) => state.persistedReducer.product);
 const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [val1, setVal1] = useState([0, 1000]);
  const [filterdata, setFilterdata] = useState([]);
  const [loader, setLoader] = useState(true);
  const { category, search , filterslug,filterslug2} = useParams()


  const [pathname, setPathname] = useState(window.location.pathname);
  // useEffect(() => {
  //   dispatch(promostionCount(40))
  //   // dispatch(addOffset(0));
  //       dispatch(promotionProducts([]));
  //   filterApi();
  //   return () => {
  //     controller.abort();
  //   };
  // }, [window.location.pathname]);
    // Store pathname in state to prevent multiple calls
    useEffect(() => {
      setPathname(window.location.pathname);
    }, [window.location.pathname]);
  
  useEffect(() => {
    const controller = new AbortController();
    dispatch(promostionCount(40));
    dispatch(addOffset(0))
    dispatch(promotionProducts([]));
    filterApi();

    // Only one call for filterApi due to pathname in state
    return () => {
      controller.abort();
    };
  }, [pathname]);
  const filterApi = async (clearFilter) => {
    const controller = new AbortController();
    setLoader(true);
    const data = {
      category: category
        ? category
        : "",
      search: search
        ? search
        : "",
      gender: (filterslug == "Men" || filterslug == "Women" || filterslug == "Everyone") && !clearFilter ? filterslug : ""
    };
    await axios
      .post(base_url + "/product/productfilter", data, {
        headers: postHeader,
        signal: controller.signal
      })
      .then(res => {
        if (res.data.status == 1) {
          var newfilterslug = clearFilter ? "" : data.gender == "" || filterslug2 == undefined ? filterslug : filterslug2;
          setFilterdata(res.data.data);
          if (res.data.data?.promotions) {
            dispatch(promotionProducts(res.data.data?.promotions));
            dispatch(promostionCount(Number(res.data.data?.promotions[0]?.page_number) == 1 && 40-Number(res.data.data?.promotions[0]?.count) ? 40-Number(res.data.data?.promotions[0]?.count) : 40))
          }
          
          dispatch(sortby(res.data.data?.sort_by[0]?.value));
          dispatch(categorydetails(res.data.data?.category_details));
          const isFilterData =  Product?.addedfilter?.filter((val) => 
            val.filter.length != 0
          );
        
          if(
            ( data.category == Product?.listcategory ||
             data?.search == Product?.listcategory) &&
             window.location.pathname == Product?.detailSlug &&
             isFilterData.length !== 0&&
             clearFilter !== true
           ){
          
             dispatch(addfilter(Product?.addedfilter))
            }
       
         else if  (data.category != Product?.listcategory  || data?.search != Product?.listcategory || newfilterslug != undefined || clearFilter == true) {
            var list = [];
         
            res.data.data?.normal_filters?.map((val) => {
            
              list.push({ title: val.title, filter: [], name: [] });
              val?.data?.map(val1 => {
                if(val.title==="Gemstone" && (category=="womens-wedding-bands" && filterslug=="Emerald")){
                   list.pop();
                  list.push({ title: val.title, filter: [], name: [] })
                }
               
                if ((newfilterslug != undefined && newfilterslug == val1.value) || val1?.selected) {
                  list.pop();
                 
                  list.push({ title: val.title, filter: [val1.value], name: [val1.name] })
                } else if (val.title == "Price") {
                  if (pathname?.includes("gift-250")) {
                    dispatch(pricefilter([val1?.range_from, 250]));
                    list.pop();
                    list.push({ title: val.title, filter: [val1?.range_from, 250], name: [val1?.range_from, 250] })
                  } else if (pathname?.includes("gift-500")) {
                    dispatch(pricefilter([val1?.range_from, 500]));
                    list.pop();
                    list.push({ title: val.title, filter: [val1?.range_from, 500], name: [val1?.range_from, 500] })
                  }else if (pathname?.includes("gift-over-2000")) {
                    dispatch(pricefilter([2000, val1?.range_to]));
                    list.pop();
                    list.push({ title: val.title, filter: [2000, val1?.range_to], name: [2000, val1?.range_to] })
                  } else {
                    dispatch(pricefilter([val1?.range_from, val1?.range_to]));
                    list.pop();
                    list.push({ title: val.title, filter: [], name: [] })
                  }

                } else if (val.title == "Carat") {
                  dispatch(caratfilter(val1));
                  var data = [];
                  list.pop();
                  list.push({ title: val.title, filter: data, name: data });
                }
              })

            });

            res.data.data?.sort_by?.map(val => {
              if (val.value == newfilterslug) {
                dispatch(sortby(val.value));
              }
            })
            if (newfilterslug == "Quick-Ship") {
              dispatch(quickship("Yes"));
            } else {
              dispatch(quickship(res.data.data.quick_ship?.value));
            }
          
            dispatch(addfilter(list));
            dispatch(listcategory(data?.category));
          }
          else {
            Product?.addedfilter?.map(val => {
              if (val.title == "Price" && val?.filter?.length) {
                dispatch(pricefilter([val?.filter[0], val?.filter[1]]));
              }
            })
          }
          // dispatch(metaDetails(res.data.data?.category_details))
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
        setLoader(false);
        filtercall();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const datasort = (obj, min, max) => {
    var data = Object.keys(obj)?.map((key) => [Number(key), obj[key]]);
    var result = [];
    var data1 = data
      .filter((val) => val[0] >= min && val[0] <= max)
      ?.map((val) => result.push(val[1]));
    return result;
  };

  const handlecheckChange = (title,value , name) => {
 
      dispatch(productlistdata([]));
    var changedata = [...addedfilter];
    addedfilter?.map((val) => {

      //------------ multi select ------------
      var filterdata = [...val.filter];
      var fname = [...val.name];

      ///------------ single select ---------------

      if(val.title==="Price" && title==="Price"){


        changedata = changedata?.map(obj =>
          obj.title == "Price"
            ? Object.assign({}, obj, { filter: [], name: [] })
            : obj
        );
        dispatch(addfilter(changedata));
      }

      else if(val.title === "Carat" && title === "Carat") {
 
          changedata = changedata?.map(obj =>
            obj.title == "Carat"
              ? Object.assign({}, obj, { filter: [], name: [] })
              : obj
          );
        
          dispatch(addfilter(changedata));
      } else if (value.includes("custom-")) {
        if (filterdata?.[0]?.includes("custom-")) {
          setcustomRedirect(true)
          setTimeout(() => {
            setcustomRedirect(false)
          }, 300)
        }
      }
      
      else if (val.title == title) {
        if (val?.filter?.includes(value) || val?.name?.includes(name)) {
          filterdata = val.filter?.filter((data) => data !== value);
          fname = val.name?.filter((data) => data !== name);
        } else {
          filterdata.push(value);
          fname.push(name);
        }
        changedata = changedata?.map(obj =>
          obj.title == title
            ? Object.assign({}, obj, { filter: filterdata, name: fname })
            : obj
        );
     
        dispatch(addfilter(changedata));
      }
    });
  };

  const clearfilter = async () => {
    var url = window.location.pathname.replaceAll("%20", " ").replaceAll(filterslug, "").replaceAll("/" + filterslug2, "");
    navigate(url);
    if (promotionsItem) {
      dispatch(promotionProducts([]));
  }
      dispatch(productlistdata([]));
      dispatch(productcount(0));
      dispatch(addOffset(0));
    await filterApi(true);
  }
  const [activeTab, setActiveTab] = useState(
    (pathname.includes("gift-250") || pathname.includes("gift-500") || pathname.includes("gift-over-2000")) ? "5" : "0"
  );
  return (
    <>
      {
        customRedirect && <Navigate to="/productlist/custom-jewelry" />
      }
      {loader ?
        <div className='skeleton px-4 m-5 mobile_hide'>
          <div className='filter_tabs'>
            <Skeleton height={90} />
          </div>
          <div className="d-flex justify-content-center">
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
            <div className="m-4"><Skeleton className="rounded" height={100} width={100} /></div>
          </div>
          <Row>
            <Col md={6}>
              <div className='d-flex'>
                <div className='me-3'><Skeleton height={35} width={35} /></div>
                <div><Skeleton height={35} width={200} /></div>
              </div>
            </Col>
            <Col md={6}>
              <div><Skeleton className='float-end' height={35} width={400} /></div>
            </Col>
          </Row>
        </div> :
        <>
          {/* Desktop view */}
          <section className='filter_box mobile_hide'>
            {/* Tabs */}
            <Tabs
      variant="tabs"
      activeKey={activeTab}
      onSelect={(selectedKey) => setActiveTab(selectedKey)}
      className="filter_tabs"
      fill
    >
      <Tab eventKey="SHOPBY" title="SHOP BY" disabled></Tab>
      {filterdata?.normal_filters?.map((val, index) =>
        val?.filter_type === 1 ? (
          <Tab
            eventKey={index.toString()}
            title={val.title}
            className={`tab-item ${activeTab === index.toString() ? 'active' : ''}`}
          >
            <Productfilter1 data={val} index={index} />
          </Tab>
        ) : (
          <Tab eventKey={index} title={val.title} className={val.title}>
          <Productfilter2 data={val} index={index} range={val?.title == "Price" ? Product?.pricefilter : Product?.caratfilter} />
        </Tab>
        )
      )}
    </Tabs>
            {/* <Tabs variant="tabs"
              defaultActiveKey={(pathname.includes("gift-250") || pathname.includes("gift-500") || pathname.includes("gift-over-2000")) ? "5" : "0"}
              className="filter_tabs"
              fill
            >
              <Tab eventKey="SHOPBY" title="SHOP BY" disabled></Tab>
              {filterdata?.normal_filters?.map((val, index) =>
                val?.filter_type == 1 ?
                  <Tab eventKey={index} title={val.title} className={val.title}>
                    <Productfilter1 data={val} index={index} />
                  </Tab> :
                  <Tab eventKey={index} title={val.title} className={val.title}>
                    <Productfilter2 data={val} index={index} range={val?.title == "Price" ? Product?.pricefilter : Product?.caratfilter} />
                  </Tab>
              )}
            </Tabs> */}


          </section>
          <div className='filter_list filter_list_mobile'>
            <Row className='justify-content-between'>
              <Col md={3} xs={6}>
                <div className='filter_left d-flex'>
                  <div className='total_count'>{Product?.productcount ? Product?.productcount : <Skeleton baseColor='#f9f9f8' height={15} width={45} />} </div>
                  <div className='quick_ship d-flex'>{filterdata?.quick_ship?.title}
                    <Form>
                      <Form.Check type="switch" onChange={() => dispatch(quickship(quickshipvalue == "Yes" ? "" : "Yes"))} checked={quickshipvalue == "Yes"} id="custom-switch" aria-label='Quick Ship' />
                    </Form>
                  </div>
                </div>
              </Col>
              <Col md={3} xs={6}>
                <div className='filter_right'>
                  {/* <DropdownButton id="shortby-button" title={!sortbyvalue?.length ? "SORT BY" : sortbyvalue} onSelect={(e) => dispatch(sortby(e))}>
                    {filterdata?.sort_by?.map(val =>
                      <Dropdown.Item eventKey={val?.value}>{val?.name}</Dropdown.Item>
                    )}
                  </DropdownButton> */}
                  <div className='filter-dropdown'>
                    <select id="shortby-button" value={sortbyvalue} onChange={(e) => {dispatch(sortby(e.target.value)); dispatch(productlistdata([]));}}
                    >
                      {filterdata?.sort_by?.map(val =>
                        <option value={val?.value}>{val?.name}</option>
                      )}
                    </select>
                    {/* <span className='filter-dropdown-arrow'></span> */}
                  </div>
                </div>
              </Col>
            </Row>

            <div className='added_filters'>
              <ul className='filterlist'>

                {addedfilter?.map((val,index) =>
                  val.title == "Carat" && val?.filter?.length ?
                    <li><Link>{val?.filter[0] == '' ? "0ct": val?.filter[0]} - {val?.filter[val?.filter?.length - 1]} <span onClick={() => handlecheckChange(val.title, val?.filter, val)} className='remove'>x</span></Link></li>
                    :
                    val.title == "Price" && val?.filter?.length ?
                      <li><Link>{val?.filter[0]} - {val?.filter[1]} <span onClick={() => handlecheckChange(val.title, val?.filter, val)} className='remove'>x</span></Link></li>
                      :
                      val?.name?.map((val1, index) =>
                        val1.length ? <li><Link>{val1} <span className='remove' onClick={() => handlecheckChange(val.title, val?.filter[index], val1)}>x</span></Link></li> : ""
                      )
                )}
                {addedfilter?.filter(val => val?.filter?.length > 1).filter(val => val?.filter != "").length ? <li id="clearFilter" onClick={clearfilter}>CLEAR ALL</li> : ""}
              </ul>
            </div>

          </div>


        </>}
      {/* Mobile View */}
      <div className='filter_box desktop_hide'>
        <Button className='mobile_filter_toggal' onClick={handleShow}>
          SORT & FILTER
        </Button>

        <Offcanvas show={show} onHide={handleClose} className='mobile_filter_box'>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className='mobile_filter_title'>SORT & FILTER</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className='p-0'>
            <Accordion defaultActiveKey="0" flush>

              {filterdata?.normal_filters?.map((val, index) =>
                val?.filter_type == 1 ?
                  <Accordion.Item eventKey={index}>
                    <Accordion.Header>{val.title}</Accordion.Header>
                    <Accordion.Body className={val.title}>
                      <Productfilter1 data={val} index={index} />
                    </Accordion.Body>
                  </Accordion.Item> :
                  <Accordion.Item eventKey={index}>
                    <Accordion.Header>{val.title}</Accordion.Header>
                    <Accordion.Body className={val.title}>
                      <Productfilter2 data={val} index={index} range={val?.title == "Price" ? Product?.pricefilter : Product?.caratfilter} />
                    </Accordion.Body>
                  </Accordion.Item>
              )}
            </Accordion>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  )
}

export default Filter